export const KEYBOARD_KEYS: Record<string, string> = {
	ArrowLeft: 'ArrowLeft',
	ArrowRight: 'ArrowRight',
	Home: 'Home',
	End: 'End',
}
